import React from "react";
import { IconeWhatsApp } from "./Icones";

/**
 * Escada de acionamento. A ordem é definida pelo time e não muda com o
 * rodízio: é ela que garante que ninguém fica sem resposta quando o
 * plantonista do dia não consegue atender.
 */
export default function NiveisApoio({ apoio, titulo, descricao }) {
  return (
    <section className="apoio" aria-labelledby="apoio-titulo">
      <header className="secao__cabecalho">
        <h2 id="apoio-titulo">{titulo}</h2>
        {descricao && <p className="secao__descricao">{descricao}</p>}
      </header>

      <ol className="apoio__lista">
        {apoio.map((pessoa, i) => (
          <li key={pessoa.id} className="apoio__item">
            <span className="apoio__nivel" aria-hidden="true">
              {i + 1}
            </span>
            <img className="avatar avatar--sm" src={pessoa.foto} alt="" />
            <span className="apoio__nome">
              {pessoa.primeiroNome}
              <span className="sr-only"> — nível {i + 1}</span>
            </span>
            <a
              className="botao botao--discreto"
              href={pessoa.whatsapp}
              target="_blank"
              rel="noreferrer"
              aria-label={`Chamar ${pessoa.primeiroNome} no WhatsApp`}
            >
              <IconeWhatsApp size={16} />
              <span className="botao__texto">WhatsApp</span>
            </a>
          </li>
        ))}
      </ol>
    </section>
  );
}
